import React, {Fragment} from "react";
import {withRouter} from "react-router-dom";
import CustomerService from "../../services/CustomerService";
import {Card, CardBody, CardGroup, Col, Container, Form, Input, InputGroup, Row} from "reactstrap";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import {Spinner} from "react-bootstrap"
import "../../scss/CustomerSearch.css";
import ToastHelper from "../../utils/ToastHelper";
import CreateObjectRowWithLabelComponent from "../../components/CreateObjectRowWithLabelComponent";

const CUSTOMER_SEARCH = "search"
const CUSTOMER_VIEW = "view";

class CustomerSearch extends React.Component {

    constructor(props) {
        super(props);

        this.props.changeHeader("Customer Search");

        this.state = {
            viewMode: CUSTOMER_SEARCH,
            viewModeId: 1,
            idNumber: "",
            phoneNumber: "",
            customer: null,
            registration: null,
            customerLimit: null,
            transactions: [],
            beneficiaries: [],
            loading: false,
            customers: [],
            multipleCustomers: false
        };

        this.retrieveCustomer = this.retrieveCustomer.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.renderSearchComponent = this.renderSearchComponent.bind(this);
    }

    retrieveCustomer() {

        CustomerService.retrieveCustomer(this.state.idNumber, this.state.phoneNumber).then(response => {
            if (response["errors"] || response.length === 0) {
                ToastHelper.formatError(response);
                this.setState({
                    loading: false
                })
            } else if (response.length > 1) {
                this.setState({
                    multipleCustomers: true,
                    customers: response
                })
            } else {
                this.props.history.push("/customer/" + response.registrationId + "/" + CUSTOMER_VIEW)
            }
        });
    }

    validateForm() {
        return this.state.idNumber.length > 0 || (this.state.phoneNumber.length > 0 && this.state.phoneNumber.match(/^[0-9,+][0-9]{9,14}$/));
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        })
    };

    handleSubmit(event) {
        if (event.preventDefault) event.preventDefault();

        this.setState({
            loading: true
        }, () => this.retrieveCustomer());

    }

    onCloseMultipleCustomerSearch() {
        this.setState({
            multipleCustomers: false,
            loading: false
        })
    }

    onSelectCustomer(customer) {
        this.props.history.push("/customer/" + customer["registration-id"] + "/" + CUSTOMER_VIEW);
    }

    render() {
        return <Fragment>

            {this.state.multipleCustomers ? this.renderMultipleCustomerModal() : this.renderSearchComponent()}

        </Fragment>
    }

    renderSearchComponent() {

        return <div className="app flex-row align-items-center">
            <Container className={"logo-center"}>
                <Row className="justify-content-center">
                    <Col md="8">
                        <CardGroup className={"customerSearchContainer"}>
                            <Card className="p-2" style={{borderRadius: "0.6rem"}}>
                                <CardBody>
                                    <Form onSubmit={this.handleSubmit}>
                                        <Col>
                                            <Row className="mb-3">
                                                <h4 className={"customerSearchContainerHeader"}>{"Customer Search"}</h4>
                                            </Row>
                                            <hr/>
                                            <InputGroup className="mb-3">
                                                <Input className="form-control input-lg"
                                                       type="text"
                                                       placeholder="ID Number"
                                                       autoComplete="idNumber"
                                                       id="idNumber"
                                                       autoFocus
                                                       onChange={this.handleChange}
                                                       value={this.state.idNumber}/>
                                            </InputGroup>
                                            <InputGroup className="mb-3">
                                                <Input className="form-control input-lg"
                                                       type="text"
                                                       placeholder="Phone Number"
                                                       id="phoneNumber"
                                                       autoComplete="phoneNumber"
                                                       onChange={this.handleChange}
                                                       value={this.state.phoneNumber}/>
                                            </InputGroup>
                                            <Row className="mb-3">
                                                {this.state.loading ?
                                                    <SFXButtonComponent
                                                        className="btn btn-lg btn-block btn-primary"
                                                        disabled={true}>
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        />
                                                    </SFXButtonComponent>
                                                    :
                                                    <SFXButtonComponent
                                                        className="btn btn-lg btn-block btn-primary"
                                                        disabled={!this.validateForm()}
                                                    >Search</SFXButtonComponent>
                                                }
                                            </Row>
                                        </Col>
                                    </Form>
                                </CardBody>
                            </Card>
                        </CardGroup>
                    </Col>
                </Row>
            </Container>
        </div>
    }

    renderMultipleCustomerModal() {
        return <Fragment>
            <br />
            <h5 style={{textAlign: "center"}}>
                Multiple customers have been found. Please select one of the below customers.
            </h5>

            <br />
            {this.state.customers.map((customer, index) => {
                return <Fragment key={index}>
                    <Card>
                        <CardBody className={"customerSearchDetails"}>
                            <Row>
                                <Col>
                                    <CreateObjectRowWithLabelComponent label={"Customer Name"}
                                                                       className={"pull-left"}>
                                        {customer["first-name"] + " " + customer["last-name"]}
                                    </CreateObjectRowWithLabelComponent>
                                    <CreateObjectRowWithLabelComponent label={"Status"}
                                                                       className={"pull-left"}>
                                        {customer["approval-status"]}
                                    </CreateObjectRowWithLabelComponent>
                                </Col>
                                <Col>
                                    <CreateObjectRowWithLabelComponent label={"Cellphone Number"}
                                                                       className={"pull-left"}>
                                        {customer["msisdn"]}
                                    </CreateObjectRowWithLabelComponent>
                                    <CreateObjectRowWithLabelComponent label={"Id Number"}
                                                                       className={"pull-left"}>
                                        {customer["id-number"]}
                                    </CreateObjectRowWithLabelComponent>
                                </Col>
                            </Row>
                            <hr/>
                            <SFXButtonComponent className={"btn-primary"}
                                                onClick={() => this.onSelectCustomer(customer)}>
                                Select
                            </SFXButtonComponent>
                        </CardBody>
                    </Card>
                    <br/>
                </Fragment>
            })}
            <div className={"customerSearchBackBtn"}>
                <SFXButtonComponent type='button' size="md" style={{width: "50%"}}
                                    onClick={this.onCloseMultipleCustomerSearch.bind(this)}>
                    Back
                </SFXButtonComponent></div>
        </Fragment>
    }

}

export default withRouter(CustomerSearch);